module.exports = __webpack_public_path__ + "img/21.18b2012.png";